import { WideError } from '../../common/WideError';
import { IWidget } from '../../widgets';

export function getError(item?: IWidget): WideError {
    let error: WideError = null;
    if (item) {
        if (item.getError) {
            error = item.getError();
        }
        if (!error) {
            error = item.error;
        }
    }
    return error;
}
